import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    padding: 20,
    display: "flex",
    fontSize: 12,
    gap: 10
  },
  iconWrapper: {
    width: 24
  },
  detailsWrapper: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 10,
    minWidth: 0
  },
  datesWrapper: {
    display: "flex",
    justifyContent: "space-between"
  },
  activityRange: {
    whiteSpace: "nowrap"
  },
  reportDetails: {
    color: "#333333",
    textAlign: "right"
  },
  manufacturer: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  comment: {
    wordBreak: "break-word"
  },
  entryHeader: {
    display: "flex",
    justifyContent: "space-between",
    gap: 10
  },
  entryTitle: {
    display: "flex"
  },
  timeStamp: {
    whiteSpace: "nowrap"
  },
  entryButtons: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      gap: 4
    }
  },
  entryButton: {
    padding: 4,
    minWidth: 26,
    "& .MuiSvgIcon-root": {
      fontSize: 14,
      color: theme.palette.text.secondary
    }
  },
  commentBody: {
    wordBreak: "break-word"
  },
  commentTitle: {
    gap: 10,
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      display: "contents",
      gap: 4
    }
  },
  vaccinationIcon: {
    fontSize: 22
  },
  commentIcon: {
    fontSize: 20
  },
  noWrap: {
    whiteSpace: "nowrap"
  }
}));
